<script>
    import BrandImage from "@xd/components/BrandImage";
    import BrandLink from "@xd/components/BrandLink";

    export default {
        name: "BrandProductSoft",
        components: { BrandLink, BrandImage },
        props: {
            product: Object,
            visibleElements: Array,
        },
        methods: {
            checkElement(index) {
                return !this.visibleElements.includes(index.toString());
            },
        },
    };
</script>

<template>
    <div class="brand-product" :id="product.slug">
        <div class="l-container">
            <div
                class="brand-product__blur"
                :class="{ 'is-animated': checkElement('blur') }"
                data-name="blur"
            >
                <img src="/static/xd-design/brand-history/blur.svg" alt="" />
            </div>

            <header class="brand-product__header">
                <div
                    class="brand-product__title"
                    :class="{ 'is-animated': checkElement('title') }"
                    data-name="title"
                >
                    {{ product.title }}
                </div>
                <div
                    class="brand-product__date"
                    :class="{ 'is-animated': checkElement('date') }"
                    data-name="date"
                >
                    {{ product.date }}
                </div>
            </header>

            <div class="brand-product__body">
                <div class="brand-product__image image-1">
                    <brand-image
                        :image="product.image"
                        index="1"
                        :is-animated="checkElement('image-1')"
                        data-name="image-1"
                    ></brand-image>
                </div>

                <div class="brand-product__text-wrapper">
                    <div
                        class="brand-product__text text-1"
                        :class="{ 'is-animated': checkElement('text-1') }"
                        data-name="text-1"
                        v-html="product.text[0]"
                    ></div>
                </div>
            </div>

            <div class="brand-product__body">
                <div class="brand-product__image image-2">
                    <brand-image
                        :image="product.image"
                        index="2"
                        :is-animated="checkElement('image-2')"
                        data-name="image-2"
                    ></brand-image>
                </div>

                <div class="brand-product__text-wrapper">
                    <div
                        class="brand-product__text text-2"
                        :class="{ 'is-animated': checkElement('text-2') }"
                        data-name="text-2"
                        v-html="product.text[1]"
                    ></div>
                    <brand-link
                        class="brand-product__link"
                        :slug="product.slug"
                        :is-animated="checkElement('link')"
                        data-name="link"
                    ></brand-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .brand-product {
        padding: 100px 16px 40px;
        @include bp($bp-desktop-sm) {
            padding: 100px 0 40px;
        }
    }

    .brand-product__header {
        margin-bottom: 40px;
        text-align: right;
        @include bp($bp-desktop-lg) {
            flex-direction: row-reverse;
            margin-bottom: 80px;
        }
    }

    .brand-product__body {
        @include bp($bp-desktop-lg) {
            display: flex;
            margin: 0 -36px;
            &:last-child {
                align-items: flex-end;
            }
        }
    }

    .brand-product__image {
        &.image-1 {
            width: calc(100% + 64px);
            margin-left: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 48.8%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 920px;
                margin: 0 36px 64px;
            }
        }

        &.image-2 {
            width: calc(100% + 32px);
            margin-left: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 88.4%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 552px;
                margin: 0 36px;
            }
        }
    }

    .brand-product__text-wrapper {
        @include bp($bp-desktop-lg) {
            flex-grow: 1;
            margin: 0 36px;
        }
    }

    .brand-product__text {
        &.text-1 {
            margin-bottom: 40px;
            @include bp($bp-desktop-lg) {
                max-width: 200px;
            }
        }

        &.text-2 {
            @include bp($bp-desktop-lg) {
                max-width: 295px;
            }
        }
    }

    .brand-product__link {
        margin-top: 40px;
    }

    .brand-product__blur {
        left: -132px;
        top: -30px;
        @include box(267px);
        @include bp($bp-desktop-lg) {
            left: auto;
            top: auto;
            right: -338px;
            bottom: 85px;
            @include box(464px);
        }
    }
</style>
